import React, { FC, useEffect, useRef } from 'react'
import { Wrapper } from './Wrapper'

type SendProps = {
  disabled: boolean
  redirectToStory?: number
}

const Send: FC<SendProps> = ({ disabled, redirectToStory }) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (redirectToStory) {
      buttonRef.current && buttonRef.current.focus()
    }
  }, [redirectToStory])

  return (
    <Wrapper
      tabIndex={0}
      type="submit"
      tip={intl.formatMessage({
        id: 'chat / input / send',
      })}
      className="is-send"
      disabled={disabled}
      buttonRef={buttonRef}
    >
      <span className="fa fa-paper-plane-top" />
    </Wrapper>
  )
}

export default Send
